import PropTypes from 'prop-types';
import { useState } from 'react';
import cx from 'classnames';
import { ArrowUpIcon } from '@ring-icons';

import './index.less';

function Collapse({ title, children }) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="collapse">
      <div onClick={() => setCollapsed(!collapsed)} className="collapse__header">
        <b>{title}</b>
        <ArrowUpIcon className={cx('collapse__header__arrow', `collapse__header__arrow--${collapsed ? 'down' : 'up'}`)} />
      </div>
      <div className="collapse__container">{!collapsed && children}</div>
    </div>
  );
}

Collapse.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Collapse;
